import { render } from "./SmartworksCentral.vue?vue&type=template&id=5199c688"
import script from "./SmartworksCentral.vue?vue&type=script&lang=js"
export * from "./SmartworksCentral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__